import { render } from "./Anniversary2022.vue?vue&type=template&id=a03b07d8&scoped=true"
import script from "./Anniversary2022.vue?vue&type=script&lang=ts"
export * from "./Anniversary2022.vue?vue&type=script&lang=ts"

import "./Anniversary2022.vue?vue&type=style&index=0&id=a03b07d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a03b07d8"

export default script